import {
  IonButton,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar
} from "@ionic/react";

import QuoQuestBotBackground from "../assets/graphics/quoquest_bot_bg.png";
import QuoQuestBot from "../assets/graphics/QQ_HeroImage.png";
import SingleMultiPlayer from "../components/SingleMultiPlayer";
import HelpButton from "../components/HelpButton";
import { useHelpStore } from "../stores/help.store";

const QuoQuestLanding: React.FC = () => {
  const { setIsHelpOpen, setActiveHelpId } = useHelpStore(state => state);
  setActiveHelpId("quo_quest_landing");
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle className="capitalize font-normal pt-4">QuoQuest</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <div className="transition-all flex flex-col justify-between h-full">
          <div className="grow flex flex-col justify-center relative">
            <h1 className="text-5xl text-white font-semibold text-center">
              QuoQuest
            </h1>
            <SingleMultiPlayer className="my-4" />
            <img
              src={QuoQuestBot}
              alt="Quest Bot"
              className="mx-auto max-h-[16.25rem]"
            />
            <div className="absolute w-full top-2 -z-10 flex flex-col">
              <img
                src={QuoQuestBotBackground}
                alt="Quest Bot Background"
                className="w-full"
              />
              <div className="bg-gradient-to-t from-primary-90 to-transparent -mt-24 h-24 w-full" />
            </div>
            <div className="px-10 pt-4 text-lg ion-text-center text-primary-20">
              Travel through time and navigate your way through the markets on
              your quest to be king of the QUO
            </div>
          </div>
          <div className="mb-[36px]">
            <div className="ion-text-center py-2 px-4">
              <IonButton
                color="primary"
                className="h-16 text-base"
                expand="block"
                routerLink="/quest/levels"
              >
                Continue
              </IonButton>
            </div>
            <div className="ion-text-center py-2 px-4">
              <IonButton
                fill="outline"
                className="text-white h-16 text-base"
                expand="block"
                onClick={() => setIsHelpOpen(true)}
              >
                How it works
              </IonButton>
            </div>
          </div>
        </div>
        <HelpButton id="quo_quest_landing" />
      </IonContent>
    </IonPage>
  );
};

export default QuoQuestLanding;
